// extracted by mini-css-extract-plugin
export default {"accordion":"IAAFaq","faq-heading":"CdBIQJ","faqHeading":"CdBIQJ"};